<script setup>
import { onMounted } from 'vue'
import HeaderView from './components/HeaderView.vue'
import FooterView from './components/FooterView.vue'
import { RouterView } from 'vue-router'

// Set default language
onMounted(() => {
  document.documentElement.setAttribute('lang', 'bg')
})
</script>

<template>
  <!-- <HeaderView /> -->
  <RouterView />
  <!-- <FooterView /> -->
</template>
